import PropTypes from 'prop-types';
import HeaderRowType from './PVPartnerContentHeaderRow';
import FormType from './PVPartnerContentForm';

const headerType = PropTypes.shape({
    header: PropTypes.shape({
        class: PropTypes.string.isRequired,
        textColorClass: PropTypes.string.isRequired,
        title: PropTypes.string,
        imgPathLogo: PropTypes.string,
        src: PropTypes.array,
        imgBgClass: PropTypes.string,
        body: PropTypes.string.isRequired,
    }).isRequired,
    headerBottomRow: HeaderRowType,
    formData: FormType,
    download: PropTypes.string,
    //download: PropTypes.string({
    //    link: PropTypes.string,
    //}),
});

export default headerType;
